/**
 * The one geometry the stylesheet cannot own.
 *
 * A meter's fill is a *value* — 38% of a build, 2 of 4 channel units — not a length from the
 * design system's scale, so there is no token for it and there could not be one. It is
 * passed as a CSS custom property rather than as a `width`, so the stylesheet still decides
 * what "filled" looks like and the component only says how full.
 *
 * Note what this is not: it is not a raw px value and it is not a colour. `pnpm lint:styles`
 * governs the stylesheet; the adherence checker governs the literals here; a percentage
 * offends neither, because neither is about percentages.
 */
import type { CSSProperties } from "react";

import { meterFillPercent } from "@wetalk/view-model/meter";

/** Moved to `@wetalk/view-model/meter` (plan-034 VIEW-PKG); re-exported here so no portal importer changes. */
export { meterPercent } from "@wetalk/view-model/meter";

/** Clamped, so a server that reports 118% does not draw a bar out of its track. */
export function meterStyle(percent: number): CSSProperties {
  return { "--c-meter-fill": `${String(meterFillPercent(percent))}%` } as CSSProperties;
}
